import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class CreditGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Credit',
            ROUTE_PATH.credit,
            ROUTE_PATH.addCredit,
            true,
            true,
            8,
            false,
            true,
            ['type_name'],
            true,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            { evalKey: '', evalParam: [1], decisiveParam: false },
            false,
            false,
            true,
            null,
            { evalKey: 'is_delete', evalParam: ["1"], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            true,
            [],
            true,


        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const type_name = new Headers('Type', 'type_name', false, true, 'text');
        const batch_number = new Headers('Batch', 'batch_number', false, true, 'text');
        const yearSelected = new Headers('Year', 'yearSelected', false, true, 'text');
        const credits = new Headers('Credit', 'credits', false, true, 'text');

        headers.push(type_name);
        headers.push(batch_number);
        headers.push(yearSelected);
        headers.push(credits);

        return headers;
    }
}